module.exports = __webpack_public_path__ + "img/trash_filled_32.01752ad1.svg";